import type { MDXComponents } from 'mdx/types';

import { TableBody, TableHead, TableHeader, TableRow } from '@nucleus-commerce/ui/components/table';

import { ApiKeyInline } from './api-key-inline';
import { Callout } from './callout';
import { CodeTabs } from './code-tabs';
import { EndpointLink } from './endpoint-link';
import {
  MdxAnchor,
  MdxBlockquote,
  MdxCode,
  MdxH2,
  MdxH3,
  MdxH4,
  MdxHr,
  MdxOl,
  MdxP,
  MdxTable,
  MdxTd,
  MdxUl,
} from './mdx-elements';
import { MdxPre } from './mdx-pre';
import { Steps } from './steps';

/** Element mapping for every guide: prose on `packages/ui` primitives plus the docs components. */
export const mdxComponents: MDXComponents = {
  h2: MdxH2,
  h3: MdxH3,
  h4: MdxH4,
  p: MdxP,
  a: MdxAnchor,
  ul: MdxUl,
  ol: MdxOl,
  blockquote: MdxBlockquote,
  table: MdxTable,
  thead: TableHeader,
  tbody: TableBody,
  tr: TableRow,
  th: TableHead,
  td: MdxTd,
  code: MdxCode,
  pre: MdxPre,
  hr: MdxHr,
  ApiKeyInline,
  Callout,
  CodeTabs,
  EndpointLink,
  Steps,
};
